import React from "react";

import { SET_BY_MARGIN_ENUMS } from "../../../system/globalEnums";
import AppliesToCategories from "../AppliesToCategories/AppliesToCategories";
import { getGroupDisplayText } from "../../utility";

const TableCustomAppliesToField = ({ row, groupArray, groupType }) => {
  const categoryText =
    groupType === SET_BY_MARGIN_ENUMS.PRODUCT.value
      ? "Products"
      : groupType === SET_BY_MARGIN_ENUMS.CATEGORY.value
      ? "Categories"
      : groupType === SET_BY_MARGIN_ENUMS.TYPE.value
      ? "Types"
      : "Sub Categories";

  return (
    <>
      {
        //if length of elements is greater than one we will show the count and a tooltip showing there names
        groupArray.length > 1 ||
        (groupArray.length === 1 &&
          groupArray.reduce(
            (totalChars, categoryOrType) =>
              totalChars + categoryOrType?.categoryName?.length,
            0
          ) > 30) ? (
          <>
            <AppliesToCategories
              key={row.id}
              anchorSelect={`#tool-${row.id}`}
              categories={groupArray}
              groupType={groupType}
              className={
                "applies-to-category container-scrollbar category-tooltip-wrapper"
              }
            ></AppliesToCategories>

            <button
              key={row.id}
              id={`tool-${row.id}`}
              className="action-Button-Wrapper ps-0"
            >
              {groupArray.length} {categoryText}
            </button>
          </>
        ) : (
          <div className="applies-to-category text-truncate">
            {groupArray.map((categoryOrType, index) => (
              <span key={index} className="text-truncate">
                {getGroupDisplayText(categoryOrType, groupType)}
                {index < groupArray.length - 1 ? ", " : ""}
              </span>
            ))}
          </div>
        )
      }
    </>
  );
};

export default TableCustomAppliesToField;
